export const ctiaSupportEmail = "certification@ctiacertification.org";
export const cbrsSupportEmail = "admin@cbrsalliance.org";

export const getRequestMailtoInfo = ({ tn, modelName, vendor }) => {
  return {
    tn,
    modelName,
    vendor
  };
};



// WEBPACK FOOTER //
// ./src/helpers/Emails.js